// Control Afterpay Text Styling
setTimeout(() => {
  const squarePlacementElement = document.querySelector('square-placement');
  if (!squarePlacementElement || !squarePlacementElement.shadowRoot) return;

  const squarePlacement = squarePlacementElement.shadowRoot;

  const afterpayTextElement = squarePlacement.querySelector('.afterpay-main-text');
  if (afterpayTextElement) {
    afterpayTextElement.style.fontSize = '12px';
    afterpayTextElement.style.marginRight = '5px';
    afterpayTextElement.style.color = '#222';
    afterpayTextElement.style.lineHeight = '14px';
    afterpayTextElement.style.fontWeight = '700';
  }

  const logoBadgeElement = squarePlacement.querySelector('.afterpay-logo.type-badge svg');
  if (logoBadgeElement) {
    logoBadgeElement.style.height = '30px';
    logoBadgeElement.style.position = 'relative';
    logoBadgeElement.style.left = '-10px';
    logoBadgeElement.style.top = '2px';
  }

  const afterpayButtonElement = squarePlacement.querySelector(
    'button.afterpay-logo.brand-afterpay.type-badge.black-on-mint'
  );
  if (afterpayButtonElement) {
    afterpayButtonElement.style.width = '85px';
  }
}, 1200);

// Account Login Slider
document.addEventListener('DOMContentLoaded', () => {
  const loginIcon = document.querySelector('.header__icon--account');
  const loginSlider = document.querySelector('.account-login-slider');

  if (!loginIcon || !loginSlider) return;

  const closeButton = loginSlider.querySelector('.close-button');

  loginIcon.addEventListener('click', (event) => {
    event.preventDefault();
    loginSlider.classList.toggle('active');
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      loginSlider.classList.remove('active');
    });
  }

  document.addEventListener('click', (event) => {
    if (!loginSlider.contains(event.target) && !loginIcon.contains(event.target)) {
      loginSlider.classList.remove('active');
    }
  });
});

const STICKY_ATC_ENABLED = false;

// Sticky Add to Cart (layout shift trigger)
document.addEventListener('DOMContentLoaded', () => {
  if (!STICKY_ATC_ENABLED) return;

  const productDescription = document.querySelector('.product-page .product__description');
  const productPageWithForm = document.querySelector('.product-page div:has(> .product-form)');

  if (!productDescription || !productPageWithForm) return;

  const descriptionOffsetTop = productDescription.offsetTop;

  const handleScroll = () => {
    if (window.scrollY >= descriptionOffsetTop) {
      productPageWithForm.classList.add('sticky-atc-after');
    } else {
      productPageWithForm.classList.remove('sticky-atc-after');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

// Sticky button width behaviour
document.addEventListener('DOMContentLoaded', () => {
  if (!STICKY_ATC_ENABLED) return;

  const button = document.querySelector('.product-page .product-form__buttons button:first-child');
  if (!button) return;

  const stickyPosition = button.getBoundingClientRect().top + window.scrollY;

  const handleButtonWidth = () => {
    if (window.scrollY < stickyPosition) {
      button.classList.add('sticky-full-width');
    } else {
      button.classList.remove('sticky-full-width');
    }
  };

  window.addEventListener('scroll', handleButtonWidth);
  handleButtonWidth();
});

function setInitialPrice() {
  if (typeof window.jQuery === 'undefined') return;
  const $span = window.jQuery('.onetime-radio > span');
  if (!$span.length) return;

  const priceText = $span.text().trim();
  const price = priceText.match(/\$[\d,.]+/);
  if (price) {
    $span.attr('data-price', `${price[0]} AUD`);
  }
}

function updatePriceOnVariantChange() {
  if (typeof window.jQuery === 'undefined') return;
  const $span = window.jQuery('.onetime-radio > span');
  if (!$span.length) return;

  const priceText = $span.text().trim();
  const price = priceText.match(/\$[\d,.]+/);
  if (price) {
    $span.attr('data-price', `${price[0]} AUD`);
  }
}

function observePriceChange() {
  const target = document.querySelector('.onetime-radio > span');
  if (!target) return;

  const observer = new MutationObserver(() => {
    const priceText = target.textContent.trim();
    const priceMatch = priceText.match(/\$[\d,.]+/);
    if (priceMatch) {
      target.setAttribute('data-price', `${priceMatch[0]} AUD`);
    }
  });

  observer.observe(target, { childList: true, characterData: true, subtree: true });
}

const quickAddButton = document.querySelector('.jci-faux-quick-add-button');
if (quickAddButton && typeof window.wrapPriceInSpan === 'function') {
  setTimeout(() => {
    quickAddButton.addEventListener('click', window.wrapPriceInSpan);
  }, 3000);
}

const backToTopButton = document.querySelector('.back-to-top-button');
if (backToTopButton) {
  backToTopButton.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// Review helpers
function generateStars(rating, element) {
  if (!element) return;

  const fullStar = '★';
  const emptyStar = '☆';
  const roundedRating = Math.round(rating);
  let starsHtml = '';

  for (let i = 1; i <= 5; i += 1) {
    starsHtml += i <= roundedRating ? fullStar : emptyStar;
  }

  element.innerHTML = starsHtml;
}

function displayReview(reviewsArray, index) {
  if (!reviewsArray.length) return;

  const reviewElement = document.querySelector('.jci-review-section .review');
  const profileElement = document.querySelector('.jci-review-section .review-profile .profile-icon');
  const reviewStarsElement = document.getElementById('review-stars');
  const reviewTextElement = document.querySelector('.review-text');
  const reviewAuthorElement = document.querySelector('.review-author');

  if (!reviewElement || !profileElement || !reviewStarsElement || !reviewTextElement || !reviewAuthorElement) return;

  const review = reviewsArray[index];
  reviewElement.classList.add('slide-up');

  generateStars(review.reviewRating, reviewStarsElement);
  reviewTextElement.innerText = review.reviewContent;
  reviewAuthorElement.innerText = review.reviewerName;
  profileElement.innerText = review.reviewerName.charAt(0);

  setTimeout(() => {
    reviewElement.classList.remove('slide-up');
  }, 800);

  const nextIndex = (index + 1) % reviewsArray.length;
  setTimeout(() => displayReview(reviewsArray, nextIndex), 5000);
}

function populateReviews() {
  const overallRatingElement = document.querySelector('.jdgm-rev-widg__summary-average a');
  const reviewCountElement = document.querySelector('.jdgm-rev-widg__summary-text');
  const overallStarsElement = document.getElementById('overall-stars');
  const reviewCountOutput = document.querySelector('.review-count');

  if (!overallRatingElement || !reviewCountElement || !overallStarsElement || !reviewCountOutput) return;

  const ratingText = overallRatingElement.innerText.split(' ')[0];
  const rating = parseFloat(ratingText);
  const totalReviewsMatch = reviewCountElement.innerText.match(/\d+/);
  const totalReviews = totalReviewsMatch ? totalReviewsMatch[0] : '0';

  generateStars(rating, overallStarsElement);
  reviewCountOutput.innerText = `${totalReviews} Reviews`;

  const reviewItems = document.querySelectorAll('.jdgm-rev');
  const reviewsArray = [];

  reviewItems.forEach((review) => {
    const reviewerNameElement = review.querySelector('.jdgm-rev__author');
    const reviewContentElement = review.querySelector('.jdgm-rev__body');
    const reviewRatingElement = review.querySelector('.jdgm-rev__rating');

    if (!reviewerNameElement || !reviewContentElement || !reviewRatingElement) return;

    const reviewerName = reviewerNameElement.innerText;
    const reviewContent = reviewContentElement.innerText;
    const reviewRating = parseInt(reviewRatingElement.getAttribute('data-score'), 10);

    reviewsArray.push({ reviewerName, reviewContent, reviewRating });
  });

  if (reviewsArray.length) {
    displayReview(reviewsArray, 0);
  }
}

const isProductPage = document.querySelector('.product-page');
if (isProductPage) {
  setTimeout(() => {
    populateReviews();

    const reviewSection = document.querySelector('.jci-review-section');
    if (reviewSection) {
      reviewSection.style.display = 'block';
      requestAnimationFrame(() => {
        reviewSection.classList.add('show');
      });
    }
  }, 3000);
}

setTimeout(() => {
  if (typeof window.jQuery === 'undefined') return;

  window.jQuery(($) => {
    const isProduct = $('body').hasClass('product-page');

    const runAccordion = () => {
      $('.accordion-content').slideDown(0);
      $('.accordion-title').on('click', function () {
        const accordionItem = $(this).parent();
        const accordionContent = $(this).next('.accordion-content');

        accordionContent.slideToggle(400);
        accordionItem.toggleClass('open');
      });
    };

    const styleAfterPay = () => {
      $('.afterpay-main-text').attr(
        'style',
        'font-size: 12px;margin-right: 5px;color: #222;line-height: 14px;font-weight: 700;'
      );
    };

    if (isProduct) {
      runAccordion();
      styleAfterPay();
      setInitialPrice();

      const $rcWidget = $('body.product-page .rc-widget');
      if ($rcWidget.length) {
        $rcWidget.fadeIn();
      }

      $('body.product-page').on('change', '.product__info-container variant-selects input', () => {
        setTimeout(() => {
          updatePriceOnVariantChange();
          observePriceChange();
        }, 100);
      });

      observePriceChange();
    }
  });
}, 3000);